module.exports = __webpack_public_path__ + "static/Package-9e24552684aef1f4b3a7e4248785cf86.png";